<script>

import appConfig from '@src/app.config'

import axios from 'axios'

export default {
  props: {
		data: {
			type: Object,
			required: true,
			default: () => ({}),
		},
  },
  components: {

  },
  data () {
    return {
      // tableBusy: true,
      // edls: [],
      // fields: [
      //   { key: 'address', field: 'ipAddress', label: 'IP', control: 'SearchInput', sortable: false, visible: false },
      //   { key: 'action', label: 'Action', sortable: false, visible: true }
      // ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev')
    }
  },
  computed: {
    formattedIpAddresses() {
      const rows = [];
      for (let i = 0; i < this.data.ips.length; i += 3) {
        rows.push(this.data.ips.slice(i, i + 3));
      }
      return rows;
    }
  },
  // mounted () {
  //   this.loadData()
  // },
  methods: {
    // loadData (src = '') {
    //   let that = this
    //   that.isBusy = true
    //   let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
    //   const url = `${baseURL}/auto/edls`

    //   axios.get(url)
    //     .then((response) => {
    //       that.edls = response.data
    //       that.tableBusy = false
    //       console.log("response", response.data)
    //     })
    //     .catch(function () {

    //     })
    // },
    // showIPToExclusionListModal () {
    //   this.$refs['modal-add-exclusion-ip'].show()
    // },
    // validateIPv4 () {
    //   const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
    //   this.error = !ipv4Pattern.test(this.ipAddress)
    // },
    // addIPToExclusion () {
    //   this.$refs['modal-add-exclusion-ip'].hide()
    //   const address = this.ipAddress + '/' + this.ipMask
    //   const data = {
    //     address: address
    //   }
    //   let baseURL = this.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
    //   const url = `${baseURL}/auto/exclusion/ip/add`
    //   axios.post(url, data)
    //     .then(response => {
    //       console.log('Response:', response.data)
    //       this.loadData()
    //     })
    //     .catch(error => {
    //       console.error('There was an error!', error)
    //     })
    //   console.log('address', address)
    // },
    // removeIPFromExclusionList (address) {
    //   let confirmDelete = confirm("Are you sure you want to delete this IP?")
    //   if (!confirmDelete) {
    //     return
    //   }
    //   const data = {
    //     address: address
    //   }
    //   let baseURL = this.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
    //   const url = `${baseURL}/auto/exclusion/ip/remove`
    //   axios.post(url, data)
    //     .then(response => {
    //       console.log('Response:', response.data)
    //       this.loadData()
    //     })
    //     .catch(error => {
    //       console.error('There was an error!', error)
    //     })
    // },
    // closeAddIPToExclusion () {
    //   this.$refs['modal-add-exclusion-ip'].hide()
    // }
  }
}
</script>

<template>
  <Layout>
    <div class="container" style="max-width: 1420px !important;">
      <div class="row page-title align-items-center" />
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <span>
                  <h5 class="mb-1 mt-0">{{ data.name }}</h5>
                </span>
              </div>
              <div class="col-6">
                <span class="mb-1 mt-0 float-right"> {{ data.last_modified.toLocaleString() }}</span>
              </div>
            </div>
            <table class="ips">
              <tbody>
                <tr v-for="(row, rowIndex) in formattedIpAddresses" :key="rowIndex">
                  <td v-for="(ip, colIndex) in row" :key="colIndex">{{ ip }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.ips {
  width: 100%;
  border-collapse: collapse;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #EDEFF4;
  padding: 8px;
  text-align: left;
}

tr:nth-child(even) {
  background-color: #EDEFF4;
}

th {
  background-color: #4CAF50;
  color: white;
}
</style>
